import { render, staticRenderFns } from "./share-404.vue?vue&type=template&id=b9119464&scoped=true"
import script from "./share-404.vue?vue&type=script&lang=js"
export * from "./share-404.vue?vue&type=script&lang=js"
import style0 from "./share-404.vue?vue&type=style&index=0&id=b9119464&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9119464",
  null
  
)

export default component.exports